<template>
	<div id="map-include">
		<h1>{{ $t('historical-markers') }}</h1>
		<div class="row mb-4">
			<div class="col-6">
				<label for="filter-select">{{ $t('filter') }}</label>
				<select v-model="filter" id="filter-select" class="custom-select">
					<option value="">{{ $t('view_all') }}</option>
					<option v-for="(type,index) in types" :value="type" :key="index">{{ type }}</option>
				</select>
			</div>
		</div>
		<GmapMap
			:center="center"
			:zoom="zoom"
			map-type-id="roadmap"
			style="width: 100%; height: 500px"
			class="box"
			ref="map"
		>
			<GmapMarker
				:key="index"
				v-for="(m, index) in markers"
				:position="{lat: m.location.coordinates[1], lng: m.location.coordinates[0]}"
				:clickable="true"
				:draggable="false"
				@click="toggleInfo(m)"
			/>
			<gmap-info-window 
				:opened="info_window_open" 
				@closeclick="closeMarker"
				:options="info_window_options" :position="info_window_position"
				>
				<div class="box">
					<h4 v-if="info_window_marker.asset_description">{{ info_window_marker.asset_description }}</h4>
					<h4 v-else>{{ $t('description_name',info_window_marker) }}</h4>
					<p><strong>{{ $t('type') }}</strong> {{ info_window_marker.asset_type }}</p>
					<p v-if="info_window_marker.park_name"><strong>{{ $t('park_name') }}</strong> {{ info_window_marker.park_name }}</p>
					<p v-if="info_window_marker.installation_date"><strong>{{ $t('installation_date') }}</strong> {{ info_window_marker.installation_date |formatDate }}</p>
				</div>
			</gmap-info-window>		
		</GmapMap>
		<table class="table mt-4">
			<thead>
				<tr>
					<th scope="col">{{ $t('description') }}</th>
					<th scope="col" width="20%">{{ $t('type_label') }}</th>
					<th scope="col" width="20%">{{ $t('park_name_label') }}</th>
					<th scope="col" width="20%">{{ $t('installation_date_label') }}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(row,index) in resultsPage" :key="index">
					<td v-if="row.asset_description">{{ row.asset_description }}</td>
					<td v-else>{{ $t('description_name',row) }}</td>
					<td>{{ row.asset_type }}</td>
					<td>{{ row.park_name }}</td>
					<td>{{ row.installation_date | formatDate }}</td>
				</tr>
			</tbody>
		</table>
		<nav v-if="maxPages > 1" aria-label="Page Navigation">
			<ul class="pagination">
				<li class="page-item" :class="{disabled: prev.disabled }">
					<a class="page-link" @click="changePage(prev.page)" tabindex="-1" :aria-disabled="(prev.disabled) ? 'true' : 'false'">
						<i aria-hidden="true" class="far fa-angle-left"></i>
						{{ $t('previous') }}
					</a>
				</li>
				<li v-for="(item,index) in paginatedArray" :key="index" class="page-item" :class="{active: item.active}" :aria-current="(item.active) ? 'page':''">
					<a class="page-link" @click="changePage(item.page)">
						{{ item.page }} 
						<span v-if="item.active" class="sr-only">(current)</span>
					</a>
				</li>
				<li class="page-item" :class="{disabled: next.disabled }">
					<a class="page-link" @click="changePage(next.page)" tabindex="-1" :aria-disabled="(next.disabled) ? 'true' : 'false'">
						{{ $t('next') }}
						<i aria-hidden="true" class="far fa-angle-right"></i>
					</a>
				</li>
			</ul>
		</nav>		
	</div>
</template>

<script>
const WINNIPEG_CENTRE = {lat: 49.895495, lng: -97.138465};
const DATA_URL = 'https://data.winnipeg.ca/resource/e9ju-ti8v.json';
import OpenData from './libraries/OpenData'

export default {
	name: 'App',
	data() {
		return {
			zoom: 11,
			center: WINNIPEG_CENTRE,
			results: [],
			info_window_marker: {},
			info_window_open: false,
			info_window_position: null,
			info_window_options: {},
			collapsed: true,
			filter: "",
			record_count: 20,
			page_number: 1,
			pagination_count: 10,
			
		}
	},
	created() {

		this.getMarkers();
	},

	mounted() {

	},

	filters: {
		formatDate(date) {
			if (date) {
				return Intl.DateTimeFormat(navigator.language, { month: 'long', day: 'numeric', year: 'numeric' }).format(new Date(date)) 
			}
			return '';
		},
	},

	computed: {
		types() {
			return [... new Set(this.results.map(item => item.asset_type))].sort();
		},

		filteredResults() {
			return (this.filter !== "") ? this.results.filter(row => row.asset_type === this.filter) : this.results;
		},

		markers() {
			return this.filteredResults.map(item => {
				item.position = {lat: parseFloat(item.location.coordinates[1]), lng: parseFloat(item.location.coordinates[0]) }
				return item;
			})
		},

		maxPages() {
			return Math.ceil(this.filteredResults.length / this.record_count);
		},

		next() {
			return (this.page_number === this.maxPages) ? { disabled: true, page: this.page_number + 1 } : { disabled: false, page: this.page_number + 1 };
		},

		prev() {
			return (this.page_number === 1) ? { disabled: true, page: this.page_number - 1 } : { disabled: false, page: this.page_number - 1 };
		},

		paginatedArray() {
			var left_page = 1;
			var right_page = this.maxPages;

			if (this.maxPages > this.pagination_count) {
				left_page = this.page_number - (this.pagination_count / 2);
				right_page = this.page_number + (this.pagination_count / 2);
				if (left_page < 1) {
					right_page = right_page + (1 - left_page);
					left_page = 1;
				} else if (right_page > this.maxPages) {
					left_page = left_page - (right_page - this.maxPages);
					right_page = this.maxPages;
				}
			}

			let pages = [];
			for (var i = left_page; i <= right_page; i++) {
				pages.push({
					lang: null,
					page: i,
					active: (this.page_number === i),
					disabled: false,
				})
			}
			return pages;
		},

		resultsPage() {
			const index = (this.page_number - 1) * this.record_count;
			return this.filteredResults.slice(index,index + this.record_count);
		},

		getWheres() {
			let wheres = [
				[{column: 'asset_class', type: '=', params: ['MONUMENT']}]
			];
			return wheres;
		},

		getOrder() {
			return [{key: 'asset_description', direction: 'ASC'}]
		}

	},

	methods: {
		async getMarkers() {
			let params = { where_parameters: this.getWheres, order_parameters: this.getOrder };
			this.results = await OpenData.getResults(DATA_URL,params);
		},

		toggleInfo(marker) {
			Object.assign(this.info_window_marker,marker);
			this.info_window_open = true;
			this.info_window_position = marker.position;
		},		

		closeMarker() {
			this.info_window_open=false;
		},

		changePage(page) {
			if ((page >= 1) && (page <= this.maxPages) && (this.page_number !== page)) {
				this.page_number = page;
				//document.getElementById('map-include').scrollIntoView();
			}
		}

	}
}
</script>


<style>
a:hover {
	cursor:pointer;
}
.fa-angle-left {
	margin-right: .2em;
}
.fa-angle-right {
	margin-left: .2em;
}
</style>
